import { IColumn } from '../../../../components/FilterPopup/FilterPopup';
import { IUserProfile } from '../../../../models';
import { ICollectionResponse } from '../../../commonUtils/commonModels';

export interface ISubscriptionList {
  skuName: string;
  skuDescription: string;
  totalQuantity: number;
  utilizedQuantity: number;
  orderNumber: string;
  subscriptionId: string;
  subscriptionNumber: string;
  validTill: number;
  bundleDetail: string | null;
  orderDate: number;
  isAddOn: boolean;
  id: number;
}

export interface ISubscriptionBundleResponse
  extends ICollectionResponse<ISubscriptionBundleData[]> {}

export interface IUserBundleResponse
  extends ICollectionResponse<IUserProfile> {}

export interface ISubscriptionCommonData {
  id: string;
  name: string;
  desc: string;
}

export interface ISubscriptionBundleData extends ISubscriptionCommonData {
  offering: ISubscriptionCommonData;
  kitsIncluded: IKitIncludedData[];
  isActive: boolean;
  isAddOn: boolean;
}

export interface IKitIncludedData {
  kit: IKitData;
  kitCardinality: number;
}

export interface IKitData extends IFeature {
  features: IFeature[];
}

export interface IFeature {
  desc: string;
  id: string;
  name: string;
  address: string;
}
export interface IFilterSubscriptionList {
  subscriptionList: ISubscriptionList[];
  isLoading: boolean;
  filteredColumns: IColumn[];
  setSelectedRow: (item: ISubscriptionList) => void;
  editSKUPermission: boolean;
}
export interface IToastNotification {
  content: string;
  id: number;
}

export interface ISiteResponse
  extends ICollectionResponse<ISite[]> {}
export interface ISite {
  childCount: number;
  imagePath: string;
  name: string;
  nodeId: string;
  offeringId: string;
  parentId: string;
  rootNodeId: string;
  type: string;
  address: string;
}

export interface IBundle extends IFeature {
  isActive: boolean,
  isAddOn: boolean
}
export interface IResourceGroup extends IFeature {
  desc: string;
  id: string;
  name: string;
  resourceMappings: any;
  resources: IFeature[];
}
export interface IAssociatedResources {
  id: string,
  resourceGroupId: string,
  bundleId: string,
  resourceGroup: IResourceGroup,
  bundle: IBundle,
  createdOn: string,
  activatedOn: string,
  validTo: string,
  subscriptionNumber: string,
  orderNumber: string
}

export interface IGroupedOrgSiteList {
  [key: string]: ISearchSiteList[];
}

export interface ISearchSiteList extends IFeature {
  title?: string;
  orgId?: string;
  siteId?: string;
  isNew?: boolean;
}

export interface ISearchSiteListGroup extends IFeature {
  title?: string;
  orgId?: string;
  siteId?: string;
  isNew?: boolean;
  count: number;
  name: string;
}

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const InstallerRole = 'c89b0756-51ae-4eb3-9afe-121e206881b6';

export const SUBSCRIPTION_NOTIFY_PRIOR_DAYS = 15;
export const NEW_SUBSCRIPTION_NOTIFICATION_PRIOR_DAYS = 4;
